import React from 'react';
import {useQuery} from "react-query";
import {useClient, useUserContext} from "../../hooks";
import {Alert} from "reactstrap";

export function SafeguardingDeclarationsCoordinatorAlert() {
  const { isCoordinator } = useUserContext();
  const client = useClient();
  const url = 'me/organisation_safeguarding_status';

  const { data } = useQuery({
    queryKey: [url],
    queryFn: () => client.get(url).get('data'),
    config: {
      cacheTime: 0,
      useErrorBoundary: false,
      enabled: !!isCoordinator,
    },
  })

  if (!data || !data.total || data.total === data.submitted) return null;

  function getContent() {
    if (!data.submitted) {
      return (
        <Alert color="danger" className="d-print-none">
          <strong>ALL Safeguarding declarations for your Core Team need updating.</strong> Please ask all Core Team members to check their emails and respond to the safeguarding declaration request for this year. Please contact your Church Relationship Lead (CRL) if you have any questions or need any support.
        </Alert>
      )
    } else {
      const remaining = data.total - data.submitted;

      return (
        <Alert color="warning" className="d-print-none">
          <strong>{remaining} of your Core Team Safeguarding declarations need updating.</strong> Please check the Core Team Applications tab to view the status for each team member and follow up accordingly. Please contact your Church Relationship Lead (CRL) if you have any questions or need any support.
        </Alert>
      )
    }
  }

  return (
    getContent()
  )
}